var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-template",
    [
      _c("template", { slot: "page-content" }, [
        _c("div", { staticClass: "cabanas--template page-template" }, [
          _c("div", {
            staticClass: "db fixed top-0 bottom-0 w-100 vh-100 bg-cream z-2",
          }),
          _vm._v(" "),
          _vm.page.background_color
            ? _c("div", {
                staticClass: "db fixed top-0 bottom-0 w-100 vh-100 z-2",
                style: {
                  opacity: 1.1 - _vm.bgOpaciy,
                  "background-color": _vm.page.background_color,
                },
              })
            : _c("div", {
                staticClass: "db fixed top-0 bottom-0 w-100 vh-100 bg-blue z-2",
                style: {
                  opacity: 1.1 - _vm.bgOpaciy,
                  "background-color": _vm.page.background_color,
                },
              }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "relative container-fluid mw9 center z-3 pt4 pb3" },
            [
              _c(
                "h1",
                {
                  staticClass:
                    "headingIcon is-cream f40px is-lorano-bold relative dib",
                },
                [
                  _vm._v(_vm._s(_vm.page.heading_title)),
                  _c("img", {
                    staticClass: "absolute",
                    attrs: { alt: "Info", src: _vm.page.hero_image },
                  }),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "relative z-content" }, [
            _c("img", {
              ref: "tasteBubble",
              staticClass: "absolute",
              style: _vm.calcParallax("tasteBubble", 200, 800, "right:-70px;"),
              attrs: { src: "/uploads/tastebubble.svg" },
            }),
            _vm._v(" "),
            _c("img", {
              ref: "leftBubble",
              staticClass: "absolute",
              style: _vm.calcParallax("leftBubble", 650, 120, "left:-120px;"),
              attrs: { src: "/uploads/left-bubble.svg" },
            }),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "relative container-fluid-ns mw9 center z-content" },
            [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-sm-6 pb5" }, [
                  _c("img", {
                    staticClass: "w-100",
                    attrs: { src: _vm.page.cabanas_info.image, alt: "Cabanas" },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "container-fluid-sm" },
                    [
                      _c("h2", { staticClass: "is-tablet-cond-bold f2 pv3" }, [
                        _vm._v(_vm._s(_vm.page.cabanas_info.title)),
                      ]),
                      _vm._v(" "),
                      _c("p", {
                        staticClass: "f15px is-tablet-regular pb3 w-90 lh-copy",
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.marked(_vm.page.cabanas_info.content_text)
                          ),
                        },
                      }),
                      _vm._v(" "),
                      _c("h3", { staticClass: "is-tablet-bold f20px pv3" }, [
                        _vm._v(
                          _vm._s(_vm.page.cabanas_info.amenities_info.title)
                        ),
                      ]),
                      _vm._v(" "),
                      _vm._l(
                        _vm.page.cabanas_info.amenities_info.amenities_list,
                        function (cabanas, index, key) {
                          return _c("ul", [
                            _c(
                              "li",
                              { staticClass: "f15px is-tablet-regular" },
                              [_vm._v(_vm._s(cabanas))]
                            ),
                          ])
                        }
                      ),
                    ],
                    2
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-sm-6 pb5" }, [
                  _c("img", {
                    staticClass: "w-100",
                    attrs: { src: _vm.page.box_suites.image, alt: "Cabanas" },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "container-fluid-sm" },
                    [
                      _c("h2", { staticClass: "is-tablet-cond-bold f2 pv3" }, [
                        _vm._v(_vm._s(_vm.page.box_suites.title)),
                      ]),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "f15px is-tablet-regular pb3 w-90 lh-copy",
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.marked(_vm.page.box_suites.content_text)
                          ),
                        },
                      }),
                      _vm._v(" "),
                      _c("h3", { staticClass: "is-tablet-bold f20px pv3" }, [
                        _vm._v(
                          _vm._s(_vm.page.box_suites.amenities_info.title)
                        ),
                      ]),
                      _vm._v(" "),
                      _vm._l(
                        _vm.page.box_suites.amenities_info.amenities_list,
                        function (box, index, key) {
                          return _c("ul", [
                            _c(
                              "li",
                              { staticClass: "f15px is-tablet-regular" },
                              [_vm._v(_vm._s(box))]
                            ),
                          ])
                        }
                      ),
                    ],
                    2
                  ),
                ]),
              ]),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "w-100 pb5 flex flex-column " }, [
            _c("div", { staticClass: "bg-blue-after pv5 relative" }, [
              _c(
                "div",
                {
                  staticClass: "flex flex-column container-fluid relative z-4",
                },
                [
                  _c(
                    "h4",
                    {
                      staticClass:
                        "is-tablet-cond-bold f20px is-white center tc lh-copy pv4 dib mw6-5",
                    },
                    [_vm._v(_vm._s(_vm.page.contact_us.title))]
                  ),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass:
                        "btn-secondary has-cream-bg center mb4 mb0-m mb0-l",
                      attrs: {
                        title: _vm.page.contact_us.link_title,
                        href: _vm.page.contact_us.link,
                      },
                    },
                    [
                      _c("span", { staticClass: "text ttu" }, [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.page.contact_us.link_text) +
                            "\n              "
                        ),
                      ]),
                    ]
                  ),
                ]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "relative z-3" }, [
            _c("img", {
              ref: "smallBubble",
              staticClass: "absolute",
              style: _vm.calcParallax("smallBubble", -250, 350, "right:4vw;"),
              attrs: { src: "/uploads/small-bubble-optim.png" },
            }),
            _vm._v(" "),
            _c("img", {
              staticClass: "absolute",
              style: { top: _vm.parallax + "px", display: "none" },
              attrs: { src: "" },
            }),
          ]),
        ]),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }